<template>
    <main>
        <div class="container-fluid">
            <div class="mainButton">
                <div class="row">
                    <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                        <breadcrumbs></breadcrumbs>
                    </div>
                    <!-- <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 text-end">
                        <DownloadAction v-if="downloadAction" ref="loaddownload"></DownloadAction>
                    </div> -->
                </div>
            </div>
            <div class="page-toolbar">
                <div class="page-title">
                    <span class="title">Detail User Role</span> 
                    <span class="star"> <i class="fa-solid fa-star"></i></span>
                </div>
            </div>
        </div>

        <GenericDetail v-if="generic" ref="loadGeneric"></GenericDetail>
        <CustomDetail v-else></CustomDetail>

        <GenericMoreButton v-if="genericBtn" ref="loadgenericbtn"></GenericMoreButton>
        <CustomMoreButton v-else></CustomMoreButton>
    </main>
</template>

<script>
import { ref } from "vue";
import breadcrumbs from "@/views/modules/UserRoles/MenuList.vue";
import lang from "@/views/modules/UserRoles/language/en";
import GenericDetail from "@/components/layout/shared/generic/DetailView.vue";
import CustomDetail from "@/views/modules/UserRoles/DetailView.vue";
import GenericMoreButton from "@/components/layout/shared/generic/common/MoreButton.vue";
import CustomMoreButton from "@/views/modules/UserRoles/MoreButton.vue";
import DownloadAction from "@/components/layout/shared/generic/download/Download.vue";

    export default {
        name: "new-product",
       
        components: {
            breadcrumbs,
            GenericDetail,
            CustomDetail,
            CustomMoreButton,
            GenericMoreButton,
            DownloadAction,
        },
        data() {
            return {
                generic: true,
                genericBtn:false,
                lang:[],
                metaList: [
                    {
                        name: 'col1',
                        items: [
                            {
                                name: 'name',
                                label: lang.LBL_ROLE_NAME,
                                routePath: 'user-roles',
                            },
                            {
                                name: 'status',
                                label: lang.LBL_STATUS,
                            },
                        ]
                    },



                    {
                        name: 'col2',
                        items: [
                            {
                                name: 'date_entered',
                                label: lang.LBL_CREATED_DATE,
                                link: false,
                                routePath: ''
                            },
                            {
                                name: 'date_modified',
                                label: lang.LBL_MODIFIED_DATE,
                                link: false,
                                routePath: ''
                            },
                        ]
                    }
                ],
                moreBtn: [
                    {
                        id: 'edit',
                        path: 'user-roles',
                        label: lang.LBL_ACTION_EDIT,
                        action:'edit',
                    },
                    {
                        id: 'delete',
                        path: 'user-roles',
                        label: lang.LBL_ACTION_DELETE,
                        action:'delete',
                    },
                ],
                routePath: {
                    path: 'user-roles',
                    detail: false
                },
                downloadAction:false,
                dowlloadList:[
                    {
                        label: lang.LBL_DOWNLOAD_ONE,
                        action:"",
                        module:"",
                    },
                    {
                        label: lang.LBL_DOWNLOAD_ONE,
                        action:"",
                        module:"",
                    }
                ]
            }
        },
        mounted() {
            this.childMethod();
            this.lang = lang;
            this.showdowmload();
        },
        methods: {
          childMethod(){
                if(this.generic == true){
                    this.$refs.loadGeneric.loadGenericView(this.metaList,this.routePath);
                }
                if(this.genericBtn == true){
                    this.$refs.loadgenericbtn.loadGenericBtn(this.moreBtn);
                }
            },
            showdowmload(){
                const self = this;
                
                if(self.downloadAction == true){
                    this.$refs.loaddownload.loadDownloadView(self.dowlloadList);
                }
            }
        }
    }

</script>